import { render, staticRenderFns } from "./BuyerAgentListings.vue?vue&type=template&id=e5d4dac6&scoped=true&"
import script from "./BuyerAgentListings.vue?vue&type=script&lang=ts&"
export * from "./BuyerAgentListings.vue?vue&type=script&lang=ts&"
import style0 from "./BuyerAgentListings.vue?vue&type=style&index=0&id=e5d4dac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d4dac6",
  null
  
)

export default component.exports